module.exports = __webpack_public_path__ + "assets_1777427128813/img/logo_v1.3a0c9ddb.png";